<ngx-spinner >
    <img src="../assets/img/loader.gif" alt="" style="width: 250px; height: auto;">
</ngx-spinner>
<router-outlet />